<template>
  <div>
    <!-- 区域设置 -->
    <baseBreadcrumb :page="$t('message.areaSettings')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <div class="body">
      <el-tabs v-model="datas.status" type="card" @tab-click="search">
        <!-- 全部区域 -->
        <el-tab-pane name="" :label="$t('message.allAreas')"></el-tab-pane>
        <!-- 使用中 -->
        <el-tab-pane name="2" :label="$t('message.inUse') + `(${tabs[1].num})`"></el-tab-pane>
        <!-- 停用 -->
        <el-tab-pane name="1" :label="$t('message.disable')"></el-tab-pane>
      </el-tabs>
      <!-- 搜索 -->
      <div class="head">
        <div class="search">
          <div class="input">
            <!--  区域编号-->
            <el-input :placeholder="$t('message.areaNumber')" v-model="datas.area_number" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
        </div>

        <div class="btn">
          <!--  区域用途设置 -->
          <el-button type="primary" class="primary" @click="regionalUsageSetting">
            {{ $t("message.regionalUsageSetting") }}
          </el-button>
          <!-- 新增 -->
          <el-button type="primary" @click="add" v-if="isAuth(355)">
            {{ $t("message.add") }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection">
          <el-table-column align="center" label="NO" width="80" prop="rowNumber">
          </el-table-column>
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <!-- 楼栋 -->
          <el-table-column align="center" :label="$t('message.building')" prop="building">
          </el-table-column>
          <!-- 站点 -->
          <el-table-column align="center" :label="$t('message.site')" prop="unit">
          </el-table-column>
          <!-- 楼层 -->
          <el-table-column align="center" :label="$t('message.floor')" prop="floor">
          </el-table-column>
          <!-- 区域编号 -->
          <el-table-column align="center" :label="$t('message.areaNumber')" prop="area_number">
          </el-table-column>
          <!-- 区域尺寸(米) -->
          <el-table-column align="center" :label="$t('message.areaSizeM')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              {{ scope.row.c }} * {{ scope.row.k }} * {{ scope.row.g }}
            </template>
          </el-table-column>
          <!-- 区域库位个数 -->
          <el-table-column align="center" :label="$t('message.numberOfAreaDatabaseLocations')" prop="wms_grid_count">
          </el-table-column>
          <!-- 区域用途 -->
          <el-table-column align="center" :label="$t('message.regionalUse')" prop="wms_area_type.type">
          </el-table-column>
          <!-- 区域描述 -->
          <el-table-column align="center" :label="$t('message.areaDescription')" prop="remark" width="200px">
          </el-table-column>
          <!-- 使用状态 -->
          <el-table-column align="center" :label="$t('message.statusOfUse')" width="100px">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_show" active-color="#2C96E7 " @change="setAreaShow(scope.row)"
                :disabled="!isAuth(358)">
              </el-switch>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="100px">
            <template slot-scope="scope">
              <!-- 修改 -->
              <p style="margin-bottom: 10px">
                <el-button type="primary" class="primary" size="small" @click="edit(scope.row)" v-if="isAuth(356)">{{
                  $t("message.edit")
                }}</el-button>
              </p>

              <!-- 删除 -->
              <el-button type="success" class="dark" size="small" @click="areDelete(scope.row.id)" v-if="isAuth(357)">{{
                $t("message.delete")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 区域设置-新增/修改 -->
    <el-dialog :title="isAdd ? $t('message.add') : $t('message.edit')" :close-on-click-modal="false"
      :visible.sync="areaSettingsEditDialogVisible" width="520px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <!-- 区域所在楼栋： -->
          <el-form-item :label="$t('message.buildingWhereTheRegionIsLocated')" prop="building">
            <el-input v-model="ruleForm.building"
              :placeholder="$t('message.buildingWhereTheRegionIsLocated')"></el-input>
          </el-form-item>
          <!-- 站点 -->
          <el-form-item :label="$t('message.site') + '：'" prop="unit">
            <el-select v-model="ruleForm.unit" :placeholder="$t('message.site')">
              <el-option v-for="item in unitOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 区域所在楼层允许输入任意文本。 -->
          <el-form-item :label="$t('message.floorOfTheArea')" prop="floor">
            <el-input v-model="ruleForm.floor" :placeholder="$t('message.floorOfTheArea')"></el-input>
          </el-form-item>

          <!-- 区域用途 -->
          <el-form-item :label="$t('message.regionalUse') + '：'" prop="area_type_id">
            <el-select v-model="ruleForm.area_type_id" :placeholder="$t('message.regionalUse')">
              <el-option v-for="item in typeOptions" :key="item.id" :label="item.type" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--  区域编号：-->
          <el-form-item :label="$t('message.areaNumber') + '：'" prop="no">
            <el-input v-model="ruleForm.no" :placeholder="$t('message.areaNumber')"></el-input>
          </el-form-item>
          <!--区域尺寸(米)：  -->
          <el-form-item :label="$t('message.areaSizeM') + '：'" prop="c">
            <el-col :span="7">
              <el-form-item prop="c">
                <el-input v-model="ruleForm.c" :placeholder="$t('message.length')"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">
              <div style="text-align: center">x</div>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="k">
                <el-input v-model="ruleForm.k" :placeholder="$t('message.width')"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">
              <div style="text-align: center">x</div>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="g">
                <el-input v-model="ruleForm.g" :placeholder="$t('message.height')"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!--  区域备注：-->
          <el-form-item :label="$t('message.areaDescription') + '：'" prop="name">
            <el-input v-model="ruleForm.remark" :placeholder="$t('message.areaDescription')" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="areaSettingsEditDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" v-if="isAdd" @click="areStore">{{
          $t("message.save")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" v-else @click="areaUpdate">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 区域用途设置 -->
    <el-dialog :title="$t('message.regionalUsageSetting')" :close-on-click-modal="false"
      :visible.sync="regionalUsageSettingDialogVisible" width="620px" center>
      <div class="content">
        <el-table :data="setTypeOptions" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#F8F8F8' }" style="width: 100%">
          <!-- 细分区域用途 -->
          <el-table-column align="center" :label="$t('message.subdivisionAreaUse')" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.type" :placeholder="$t('message.regionalUse')"></el-input>
            </template>
          </el-table-column>
          <!-- 区域用途编码 -->
          <el-table-column align="center" min-width="140">
            <template slot="header">
              <el-tooltip effect="dark" :content="$t('message.regionalUsageCodeTip')" placement="top">
                <span>{{ $t('message.regionalUsageCode') }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.code" :placeholder="$t('message.regionalUsageCode')"></el-input>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="90">
            <template slot-scope="scope">
              <el-button size="small" type="danger" class="dark" @click="delType(scope.$index)">{{ $t("message.delete")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 添加类别 -->
        <el-button size="small" type="success" style="margin-top: 24px" @click="addTypeItem">{{ $t("message.addType")
        }}</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="regionalUsageSettingDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="setAreaTypeList">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      activeName: "1",
      datas: {
        page: 1,
        pageSize: 10,
        area_number: "",
      },
      total: 0,
      tableData: [],
      areaSettingsEditDialogVisible: false,
      isAdd: true,
      ruleForm: {},
      rules: {
        building: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        floor: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        no: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        c: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        k: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        g: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        area_type_id: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      unitOptions: [
        { value: 'JP', label: 'JP' },
        { value: 'ES', label: 'ES' },
        { value: 'US', label: 'US' },
        { value: 'RU', label: 'RU' },
        { value: 'BR', label: 'BR' },
     
      ],
      typeOptions: [], //区域类型
      //   区域用途设置
      regionalUsageSettingDialogVisible: false,
      setTypeOptions: [],
    };
  },
  created() {
    this.areaList();
    this.areaType();
    this.wmsAreaNum()
  },
  methods: {
    // 仓库区域列表统计
    wmsAreaNum() {
      this.$api.tabTotalApi.wmsAreaNum().then(res => {
        this.tabs = res.data
      })
    },

    areaList() {
      this.$api.warehouseApi.areaList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.is_show = item.is_show == 1 ? true : false;
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 区域-用途选项列表
    areaType() {
      this.$api.warehouseApi.areaType(this.datas).then((res) => {
        this.typeOptions = res.data;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.areaList();
    },

    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.areaList();
    },
    handleSizeChange(val) {
      this.datas.page = 1;
      this.datas.pageSize = val;
      this.areaList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    //区域-是否显示
    setAreaShow(item) {
      let datas = {
        area_number: item.area_number,
        is_show: item.is_show ? 1 : 0,
      };
      this.$api.warehouseApi.setAreaShow(datas);
    },
    // 新增
    add() {
      this.ruleForm = {
        building: "",
        unit: "",
        floor: "",
        no: "",
        c: "",
        k: "",
        g: "",
        remark: "",
        area_type_id: "",
      };
      this.areaSettingsEditDialogVisible = true;
      this.isAdd = true;
    },
    // 区域-添加区域
    areStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.warehouseApi.areStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.areaSettingsEditDialogVisible = false;
            this.areaList();
            this.wmsAreaNum()
          });
        }
      });
    },
    // 修改
    edit(item) {
      this.isAdd = false;
      this.ruleForm = JSON.parse(JSON.stringify(item));
      this.areaSettingsEditDialogVisible = true;
    },
    // 修改区域
    areaUpdate() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.warehouseApi.areaUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.areaSettingsEditDialogVisible = false;
            this.areaList();
            this.wmsAreaNum()
          });
        }
      });
    },
    // 删除区域
    areDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.warehouseApi.areDelete({ id }).then((res) => {
            this.$message.success(res.msg);
            this.areaList();
            this.wmsAreaNum()
          });
        })
        .catch(() => { });
    },
    // 区域用途设置
    regionalUsageSetting() {
      this.regionalUsageSettingDialogVisible = true;
      this.setTypeOptions = JSON.parse(JSON.stringify(this.typeOptions));
    },
    // 新增区域设置
    addTypeItem() {
      this.setTypeOptions.push({
        id: "",
        type: "",
        code: "",
      });
    },
    // 删除区域设置
    delType(i) {
      this.setTypeOptions.splice(i, 1);
    },
    // 保存区域设置
    setAreaTypeList() {
      let flag = this.setTypeOptions.every((item) => item.type != "");
      if (!flag) return this.$message.error("不能保存空的区域用途");
      this.$api.warehouseApi
        .setAreaTypeList({ list: this.setTypeOptions })
        .then((res) => {
          this.regionalUsageSettingDialogVisible = false;
          this.$message.success(res.msg);
          this.areaType();
          this.wmsAreaNum()
        });
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
  },
};
</script>
<style lang='scss' scoped>
.head {
  margin: 14px 0 24px;
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .input {
      width: 180px;
      margin-right: 40px;
    }
  }
}

.content {
  padding: 0 15px;

  /deep/.el-textarea__inner {
    height: 120px;
  }

  .el-select {
    width: 100%;
  }
}
</style>
